<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="ProjectTeam"
              @submit.prevent="onFileUpload"
            >
                <div class="content">
                    <h1>Unit Details</h1>
                    <p>Please provide the number of units by bedroom size.</p>
                    <h2>Number of Units</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.NumberOfEfficiencyUnits"
                                name="text-efficiency-units"
                                placeholder="Number of Efficiency Units"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.NumberOfOneBedroomUnits"
                                name="text-one-bedroom-units"
                                placeholder="Number of One-Bedroom Units"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.NumberOfTwoBedroomUnits"
                                name="text-two-bedroom-units"
                                placeholder="Number of Two-Bedroom Units"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.NumberOfThreeBedroomUnits"
                                name="text-three-bedroom-units"
                                placeholder="Number of Three-Bedroom Units"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.NumberOfFourBedroomUnits"
                                name="text-four-bedroom-units"
                                placeholder="Number of Four-Bedroom or more Units"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="totalUnits"
                                name="text-total-units"
                                placeholder="Total Number Units"
                                readonly
                                :disabled="true"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                    </div>
                    <div v-if="totalUnits != FullSummaryApplication.NumberOfUnits" class="columns">
                        <div class="column">
                            <callout type="danger">
                                Total Must match Total Number Of Units from Project Information Page: {{ FullSummaryApplication.NumberOfUnits }}
                            </callout>
                        </div>
                    </div>
                    <h2>Unit AMIs</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI0to20"
                                name="text-ami-0-20"
                                placeholder="Number of Units at 0-20% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI20to30"
                                name="text-ami-20-30"
                                placeholder="Number of Units at 21-30% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI30to50"
                                name="text-ami-30-50"
                                placeholder="Number of Units at 31-50% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI50to60"
                                name="text-ami-50-60"
                                placeholder="Number of Units at 51-60% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI60to80"
                                name="text-ami-60-80"
                                placeholder="Number of Units at 61-80% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="column">
                            <vee-textbox
                                v-model="FullSummaryApplication.AMI80to120"
                                name="text-ami-80-120"
                                placeholder="Number of Units at 81-120% AMI"
                                required
                                rules="required"
                                type="number"
                                min="0"
                            />
                        </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                            v-model="FullSummaryApplication.AMI120Plus"
                            name="text-ami-120-plus"
                            placeholder="Number of Units at >120% AMI"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                    </div>
                    <div class="column">
                        <vee-textbox
                            v-model="totalAMIUnits"
                            name="text-total-ami-units"
                            placeholder="Total Number of AMI Units"
                            readonly
                            :disabled="true"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                    </div>
                </div>
                <div v-if="totalAMIUnits != FullSummaryApplication.NumberOfUnits" class="columns">
                        <div class="column">
                            <callout type="danger">
                                Total Must match Total Number Of Units from Project Information Page: {{ FullSummaryApplication.NumberOfUnits }}
                            </callout>
                        </div>
                    </div>
                <h2>Unit Set-Asides</h2>
                <callout type="warning" v-if="(FullSummaryApplication.Mobility < requiredMobilityUnits && FullSummaryApplication.Mobility != '') || (FullSummaryApplication.Sensory < requiredSensoryUnits && FullSummaryApplication.Sensory != '') || (FullSummaryApplication.Clearinghouse < requiredClearinghouseUnits && FullSummaryApplication.Clearinghouse != '') || (FullSummaryApplication.DevelopmentCategory == 'New Construction' && (FullSummaryApplication.Visitable < requiredVisitableUnits && FullSummaryApplication.Visitable != ''))">
                    Units do not meet requierments. This will have to be fixed later in the process.
                </callout>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                            v-model="FullSummaryApplication.Mobility"
                            name="text-mobility-units"
                            placeholder="Number of Mobility Units"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                        <p><strong>Required Mobility Units: </strong> {{ requiredMobilityUnits }}</p>
                    </div>
                    <div class="column">
                        <vee-textbox
                            v-model="FullSummaryApplication.Sensory"
                            name="text-sensory-units"
                            placeholder="Number of Sensory Units"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                        <p><strong>Required Sensory Units: </strong> {{ requiredSensoryUnits }}</p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                            v-model="FullSummaryApplication.Visitable"
                            name="text-visitable-units"
                            placeholder="Number of Visitable Units"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                        <p v-if="FullSummaryApplication.DevelopmentCategory == 'New Construction'"><strong>Required Visitable Units: </strong> {{ requiredVisitableUnits }}</p>
                    </div>
                    <div class="column">
                        <vee-textbox
                            v-model="FullSummaryApplication.Clearinghouse"
                            name="text-clearinghouse-units"
                            placeholder="Number of Clearinghouse Units"
                            required
                            rules="required"
                            type="number"
                            min="0"
                        />
                        <p><strong>Required Clearinghouse Units: </strong> {{ requiredClearinghouseUnits }}</p>
                    </div>
                </div>
                <div class="columns">
                  <div class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="prevPage"
                      >
                      Back
                      </button>
                  </div>
                  <div class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-primary"
                      :disabled="totalAMIUnits != FullSummaryApplication.NumberOfUnits || totalUnits != FullSummaryApplication.NumberOfUnits"
                      @click="nextPage"
                      >
                      Next
                      </button>
                  </div>
              </div>
                </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import options from "@/utilities/options";

export default {
  name: 'ProjectTeam',
  mixins: [options],
  data() {
    return {
      FullSummaryApplication: null,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
  },
  computed:{
    totalUnits: function(){
        var total =  (Number(this.FullSummaryApplication.NumberOfEfficiencyUnits) || 0)
            + (Number(this.FullSummaryApplication.NumberOfOneBedroomUnits) || 0)
            + (Number(this.FullSummaryApplication.NumberOfTwoBedroomUnits) || 0)
            + (Number(this.FullSummaryApplication.NumberOfThreeBedroomUnits) || 0)
            + (Number(this.FullSummaryApplication.NumberOfFourBedroomUnits) || 0);
            return total;
    },
     totalAMIUnits: function(){
        var total =  (Number(this.FullSummaryApplication.AMI0to20) || 0)
            + (Number(this.FullSummaryApplication.AMI20to30) || 0)
            + (Number(this.FullSummaryApplication.AMI30to50) || 0)
            + (Number(this.FullSummaryApplication.AMI50to60) || 0)
            + (Number(this.FullSummaryApplication.AMI60to80) || 0)
            + (Number(this.FullSummaryApplication.AMI80to120) || 0)
            + (Number(this.FullSummaryApplication.AMI120Plus) || 0);
            return total;
    },
    requiredMobilityUnits: function(){
        return Math.ceil(this.totalUnits * 0.10);
    },
    requiredSensoryUnits: function(){
        return Math.ceil(this.totalUnits * 0.04);
    },
    requiredVisitableUnits: function(){
        return Math.ceil(this.totalUnits * 1);
    },
    requiredClearinghouseUnits: function(){
        return Math.ceil(this.totalUnits * 0.10);
    },
  },
  methods: {
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.FullSummaryApplication.TotalUnits = this.totalUnits;
            this.FullSummaryApplication.AMITotal = this.totalAMIUnits;
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "Development",
            });
        }
    },
    async prevPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "SiteInformation",
                params: { siteId: this.FullSummaryApplication.Sites.length  },
            });
        }
    },
  }
};
</script>